import React, { useState } from "react";
import { motion } from "framer-motion";
import InfiniteScroll from "react-infinite-scroll-component";
import { withTranslation } from "react-i18next";
import { useStaffOfficePolicyList } from "repositories/office-policy-management-repository";
import Loader from "components/Loader";
import Empty from "components/Empty";
import { cacheSideBarActive } from "utils";
import constants from "../../../../../constants";
import useStaffOfficePolicyModule from "../../hooks/useStaffOfficePolicyModule";
import styles from "../../OfficePolicyManagement.module.scss";
import HeaderFilter from "./filters/HeaderFilter";
import FilterOfficePolicy from "./filters";
import SearchBar from "./filters/Searchbar";
import StaffPolicyCard from "./StaffPolicyCard";

const getButtonClass = (status) => {
  const statusClasses = {
    Pending: styles.Pending,
    Cancelled: styles.Cancelled,
    Started: styles.Started,
    Accepted: styles.Accepted,
    Rejected: styles.Rejected,
    "In Progress": styles.InProgress,
    Completed: styles.Completed,
  };
  return `${styles.task_management_card_btn} ${statusClasses[status] || ""}`;
};

const StaffOfficePolicyList = ({ t, isArchive, isStaff, accountOwnerId }) => {
  const [isSidebarActive, setSidebarActive] = useState(
    cacheSideBarActive(constants.sidebar.cache.officePoliciesIsSidebarActive)
  );

  const handleSidebarToggle = () => {
    setSidebarActive(!isSidebarActive);
    localStorage.setItem(
      constants.sidebar.cache.officePoliciesIsSidebarActive,
      !isSidebarActive
    );
  };

  const {
    isLoading,
    officePolicies,
    inputValue,
    officeFilter,
    staffFilter,
    statusFilter,
    priorityFilter,
    isFilterApply,
    showLoader,
    handleSearchTerm,
    handleToggleAssigne,
    handleActionOfficePolicy,
    setOfficeFilter,
    setStaffFilter,
    setStatusFilter,
    setPriorityFilter,
    resetFilter,
    handleApplyFilters,
    handleArchiveApi,
    setSortBy,
    sortBy,
    priority,
    status,
    setStatus,
    setPriority,
    pageNumber,
    totalPages,
    setPageNumber,
  } = useStaffOfficePolicyModule(
    useStaffOfficePolicyList,
    isArchive,
    accountOwnerId
  );

  const cardClassName = !isSidebarActive
    ? styles.task_management_status_card_active
    : styles.task_management_status_card_not_active;

  return (
    <>
      {(isLoading || showLoader) && <Loader />}
    <div className={` ${styles["dropdown_radio_search_wrapper"]}}  ${styles["current-policies-search-wrapper-box"]} `}>
        <HeaderFilter
          setSortBy={setSortBy}
          sortBy={sortBy}
          priority={priority}
          setPriority={setPriority}
          status={status}
          setStatus={setStatus}
        />
        <SearchBar
          searchValue={inputValue}
          handleSearchTerm={handleSearchTerm}
          t={t}
        />
      </div>
      <div className="scheduler-tabs-main-wrapper">
        <FilterOfficePolicy
          t={t}
          isSidebarActive={isSidebarActive}
          handleSidebarToggle={handleSidebarToggle}
          resetFilter={resetFilter}
          officeFilter={officeFilter}
          setOfficeFilter={setOfficeFilter}
          handleApplyFilters={handleApplyFilters}
          staffFilter={staffFilter}
          setStaffFilter={setStaffFilter}
          statusFilter={statusFilter}
          priorityFilter={priorityFilter}
          setStatusFilter={setStatusFilter}
          setPriorityFilter={setPriorityFilter}
          isFilterApply={isFilterApply}
          isStaff={isStaff}
          accountOwnerId={accountOwnerId}
        />
        {officePolicies?.length === 0 ? (
          <div className={styles["not_found"]}>
            <Empty Message={t("officePolicyManagement.policyNotFound")} />
          </div>
        ) : (
          <motion.div
            variants={{
              hidden: {},
              show: { transition: { staggerChildren: 0.05 } },
            }}
            initial="hidden"
            animate="show"
            className="w-100"
          >
            <InfiniteScroll
              dataLength={officePolicies?.length ?? 0}
              next={() => {
                if (!isLoading && pageNumber < totalPages) {
                  setPageNumber((p) => p + 1);
                }
              }}
              hasMore={pageNumber < totalPages}
              scrollThreshold={0.9}
            >
              <div className={styles["task_management_card_grid"]}>
                {officePolicies?.map((officePolicy, index) => (
                  <StaffPolicyCard
                    key={officePolicy?.id ?? index}
                    className={cardClassName}
                    myOfficePolicy={officePolicy}
                    handleToggleAssigne={handleToggleAssigne}
                    getButtonClass={getButtonClass}
                    handleActionOfficePolicy={handleActionOfficePolicy}
                    handleArchiveApi={handleArchiveApi}
                    isArchive={isArchive}
                  />
                ))}
              </div>
            </InfiniteScroll>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default withTranslation()(StaffOfficePolicyList);
